import { render, staticRenderFns } from "./bo-numeric-counter.vue?vue&type=template&id=03980f3f"
import script from "./bo-numeric-counter.vue?vue&type=script&lang=js"
export * from "./bo-numeric-counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports